module.exports = __webpack_public_path__ + "img/web_5.1fdcc704.png";